<template>
    <v-flex xs12 pl-0 pr-0>
      <v-card hover title>
        <v-container pa-1>
          <v-layout justify-space-between>
            <v-flex no-wrap overflow-hidden>
              <div class="text-xs-left"><twitch-channel-link :channel='this.stream.channel' /></div>
              <div>{{ this.stream.channel.statusShort }}</div>
              <div>{{ this.stream.game }}</div>
            </v-flex>
            <v-flex pa-0 m-0 class="text-xs-right no-wrap" no-wrap>
              <v-icon class="pr-2">mdi-clock-outline</v-icon>
              <span>{{this.stream.uptime}}</span>
            </v-flex>
          </v-layout> 
        </v-container>
        <v-img v-if="!makeVideo" :src="highQuality ? this.ultra : this.stream.preview.medium" @click="makeVideo=true" gradient="to top right, rgba(0,0,0,.33), rgba(0,0,0,.33)">
          <v-layout justify-end no-wrap pa-2>
            <v-flex xs2 class="text-xs-right white--text">
              <v-icon small color="white">fas fa-eye</v-icon>
              {{ this.stream.viewers }}
            </v-flex>
          </v-layout>
          <v-layout align-center justify-center fill-height>
            <v-icon large color="white">fa fa-play</v-icon>
          </v-layout>
        </v-img>
        <div class="v-responsive v-image" v-if="makeVideo">
          <div class="v-responsive__sizer" style="padding-bottom: 56.6667%;"></div>
          <iframe class="v-image__image v-image__image--cover" :src="this.embed_url" allowfullscreen="allowfullscreen" frameborder="0" />
        </div>
      </v-card>
    </v-flex>
</template>

<script>
import TwitchChannelLink from '@/components/TwitchChannelLink'

export default {
  name: 'TwitchStreamCard',
  components: {
    TwitchChannelLink
  },
  props: {
    stream: Object,
    highQuality: Boolean,
  },
  data () {
    return {
      makeVideo: false,
    }
  },
  watch: {
    stream: function(){
      this.makeVideo = false
    }
  },
  computed: {
    ultra () {
      return this.stream.preview.template.replace('{width}', '1280').replace('{height}', '720')
    },
    embed_url () {
      return `https://player.twitch.tv/?channel=${this.stream.channel.name}`
    },
  }
}
</script>

<style>
  .material-icons { vertical-align: middle }
</style>